// Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import { apiGatewayClient } from './api'

/**
 * Calls the docs-assistant backend route (POST /docs-assistant/ask).
 * sessionId is omitted from the request body on the first turn of a
 * conversation, then threaded through on subsequent turns for context.
 */
export function askDocsAssistant(question, sessionId) {
  const body = sessionId ? { question, sessionId } : { question }

  return apiGatewayClient()
    .then(client => client.post('/docs-assistant/ask', {}, body, {}))
    .then(({ data }) => data)
}

// sessionStorage (not localStorage or component state): survives a page refresh
// but clears when the tab closes, matching the ephemeral lifetime of a Bedrock
// RetrieveAndGenerate session — see the "Session state" decision in
// docs/ai-assistant-runbook.md.
const SESSION_STORAGE_KEY = 'docsAssistantSessionId'

export function getStoredSessionId() {
  try {
    return sessionStorage.getItem(SESSION_STORAGE_KEY) || undefined
  } catch (error) {
    return undefined
  }
}

export function storeSessionId(sessionId) {
  try {
    if (sessionId) {
      sessionStorage.setItem(SESSION_STORAGE_KEY, sessionId)
    } else {
      sessionStorage.removeItem(SESSION_STORAGE_KEY)
    }
  } catch (error) {
    // Private mode and blocked storage must not prevent the assistant from working.
  }
}

export function clearStoredSessionId() {
  storeSessionId(undefined)
}
